import { ApiOptions } from '../../api-options.decorator';
import { ParamsAdapter } from '../../params.adapter';

import { ApiBaseMidBack } from './base';
import { MultiAccountThreadViewModel } from './types/multiAccountThreadViewModel';

/**
 * @internal
 */
export class ApiMidbackPortalThread extends ApiBaseMidBack {
  @ApiOptions({ channel: 'thread.post', requestType: 'form' })
  postMultiAccountThread(params: ParamsAdapter) {
    return this.post<MultiAccountThreadViewModel>('/portal-thread/multi-account-thread', params);
  }
}
